const experimentStore = (apiServices => ({
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    agentExperiments: {},
    leadExperiments: {},
  },
  mutations: {
    setAgentExperiments: (state, agentExperimentsObj) => {
      state.agentExperiments = agentExperimentsObj; // eslint-disable-line no-param-reassign
    },
    setLeadExperiments: (state, leadExperimentsObj) => {
      state.leadExperiments = leadExperimentsObj; // eslint-disable-line no-param-reassign
    },
  },
  actions: {
    async loadAgentExperiments(context, agentKey) {
      return apiServices.oa.agent.getAgentExperiments(agentKey)
        .then((experiments) => {
          const agentExperiments = {};

          // Set Agent split tests
          experiments.forEach((experiment) => {
            if (experiment.statustypeid === 1
              && experiment.testtag === 'AgentPortal-split-test-Mar19'
              && experiment.variations[0].variationtag === 'Test-LeadActionButtons') {
              agentExperiments.SDPLeadActionBtns = true;
            }
          });

          context.commit('setAgentExperiments', agentExperiments);
        });
    },
  },
  getters: {
  },
}));

export default experimentStore;
